import {useContext, useEffect} from 'react';
import { amplifyContext } from '../context';
import {Auth } from 'aws-amplify';

const useAuth = () => {
    
    const awsConfig = useContext(amplifyContext);
    
    // const [status, setStatus] = useState('loading')
    // const [cred, setCred] = useState({username: ''});
    
    useEffect(() => {
        Auth.configure(awsConfig);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const loggedIn = 'loggedIn';
    const loggedOut = 'loggedOut';

    

    const getCredentials = async ( setStatus = (status)=>{}) => {
        try{
            const cred = await Auth.currentAuthenticatedUser();
            if(cred.username){
                setStatus(loggedIn);
            } else {
                setStatus(loggedOut);
            }
            return cred;
        } catch(err){
            console.log("error retrieving cred", err);
            return {username: ''};
        }
    }

    const signIn = () => {
        Auth.federatedSignIn();
    }
    
    const signOut = () => {
        Auth.signOut();
    }


    return { signOut, signIn, getCredentials};
    
}

export {useAuth}